<template>
  <el-row type="flex" align="center">
    <el-col :span="6" style="position:relative;">
      <div class="system_logo">
        <img src="../../assets/images/ktscreen/danghui.png" alt="">
        <span v-if="configes.screen_general_title">{{configes.screen_general_title}}</span>
        <span v-else>红雁党建管家</span>
      </div>
    </el-col>
    <el-col :span="14">
      <MainMenu />
    </el-col>
    <el-col :span="4">
    </el-col>
  </el-row>
</template>
<script>
  import MainMenu from '@/components/MainMenu'
  import { gethomepageapi } from "@/network/api/platformghome"
  export default {
    components: { MainMenu },
    data() {
      return {
        src: "",
        configes: {}
      }
    },
    methods: {
      async getconfiglist() {
        let datas = await gethomepageapi();
        if (datas.data.res) {
          this.configes = datas.data.res
        }
      }
    },
    created() {
      this.getconfiglist();
      if (sessionStorage.ISCOM === "0") {
        this.src = require("@/assets/images/branch_logo.png")
      } else {
        this.src = require("@/assets/images/org_logo.png")
      }
    }

  }
</script>
<style>
  .system_logo {
    color: #fff;
    display: flex;
    align-items: center;
    color: #fff;
    font-size: 22px;
    font-weight: bold;
    width: 100%;
    position: absolute;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
  }

  .system_logo>img {
    width: 50px;
    margin: 0 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/MyHead/index.vue